import { backend_api_v2 } from '/src/utils/apiv2'

import { defineStore } from 'pinia'

export const useTranslationsStore = defineStore('translations', {
    state: () => ({
        langs: {},
        selected_lang: "en",
    }),
    getters: {
        translate: state => key => state.langs[state.selected_lang]?.[key] || key.replaceAll("_", " "),
        // Whether a key is really translated. `translate` cannot answer it:
        // it falls back to the humanised key, so "btl_ua_one_name" comes back
        // as "btl ua one name" and reads like a translation that exists.
        // Callers with a better fallback of their own (a schema's own label)
        // ask this first.
        hasTranslation: state => key => !!state.langs[state.selected_lang]?.[key],
    },
    actions: {
        setLang(payload) {
            this.langs[payload.lang] = payload.data
        },
        setSelectedLang(lang) {
            this.selected_lang = lang
            // Tell the browser which language the page is in. With `lang="en"`
            // on a Dutch interface, Edge and Chrome offered to translate it.
            document.documentElement.lang = lang
        },

        loadLang(lang) {
            this.setSelectedLang(lang)
            if (lang in this.langs) return
            return backend_api_v2.get('/translations/' + lang)
                .then(({ data }) => {
                    this.setLang({ lang, data })
                })
                .catch(e => console.log(`Cant load lang: ${e}`))
        },
    },
})
